<template>
  <div class="loader">
    <div class="loader__loader-bg" :style="{ width: width + 'rem', height: width + 'rem' }">
      <div class="loader__loader-bg__eclipse">
        <div v-if="text" class="loader__loader-bg__eclipse__text" :style="{ fontSize: fontSize + 'rem' }">
          <div class="loader__loader-bg__eclipse__text__center">
            {{ text }}
          </div>
        </div>
        <div class="loader__loader-bg__eclipse__spinner"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Loader",
  props: {
    text: String,
    width: {
      type: Number,
      default() {
        return 14.6;
      }
    },
    fontSize: {
      type: [String, Number],
      default() {
        return 3;
      }
    }
  }
};
</script>
